
<ng-container matColumnDef="havs">
  <mat-header-cell [crud-column-header]="columns.column('havs')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.MechanicalAspect.havs">
      Havs 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'havs', mechanicalAspectGetter, previousRevisionGetter)">
    <mat-icon *ngIf="mechanicalAspectGetter(element)?.havs">check_box</mat-icon><mat-icon *ngIf="mechanicalAspectGetter(element)?.havs == false">check_box_outline_blank</mat-icon>
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="havsRagStatus">
  <mat-header-cell [crud-column-header]="columns.column('havsRagStatus')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.MechanicalAspect.havsRagStatus">
      Havs Rag Status 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'havsRagStatus', mechanicalAspectGetter, previousRevisionGetter)">
    {{mechanicalAspectGetter(element)?.havsRagStatus | refDecode:'RAG_STATUS' | async}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="wbv">
  <mat-header-cell [crud-column-header]="columns.column('wbv')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.MechanicalAspect.wbv">
      Wbv 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'wbv', mechanicalAspectGetter, previousRevisionGetter)">
    <mat-icon *ngIf="mechanicalAspectGetter(element)?.wbv">check_box</mat-icon><mat-icon *ngIf="mechanicalAspectGetter(element)?.wbv == false">check_box_outline_blank</mat-icon>
  </mat-cell>
</ng-container> 

<ng-container matColumnDef="wbvRagStatus">
  <mat-header-cell [crud-column-header]="columns.column('wbvRagStatus')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.MechanicalAspect.wbvRagStatus">
      Wbv Rag Status 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'wbvRagStatus', mechanicalAspectGetter, previousRevisionGetter)">
    {{mechanicalAspectGetter(element)?.wbvRagStatus | refDecode:'RAG_STATUS' | async}}
  </mat-cell>
</ng-container>
